import React from "react";
import "./App.css";
import WeatherApp from './components/weatherapp/WeatherApp';

const App = () => (
  <div className="App">
  <WeatherApp />
  </div>
);

export default App;
